import React from 'react';
import ReactDOM from 'react-dom';
import { TodoApp } from './TodoApp';
ReactDOM.render(React.createElement(TodoApp, null), document.getElementById('app'));
